import MyTable from "components/UIElements/MyTable";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import  EndPoints from 'shared/endPoints/EndPoints.json';
import useHttpClient from 'shared/hooks/http-hook';
import Spinner from "components/UIElements/Spiner/Spiner";

export default function Problems() {
    const { responseData, status, sendRequest } = useHttpClient();
    const { id } = useParams();

    useEffect(() => {
        sendRequest({
            endpoint: `${EndPoints.CONTRACT.GETCONTRACT}/problems/${id}`,
            method: 'GET',
        })
    }, [sendRequest, id])

    const columns = [
        {
            title: 'IMEI Συσκευής',
            dataIndex: 'imei',
            key: 'imei',
        },
        {
            title: 'Είδος Αναφοράς',
            key: 'report',
            dataIndex: 'report',
        },
        {
            title: 'Σχόλια',
            key: 'comments',
            dataIndex: 'comments',
        },
        {
            title: 'Ημερομηνία Καταχώρησης',
            key: 'dateRegister',
            dataIndex: 'dateRegister',
        },
    ];

    if (status === "resolved") {
        return <MyTable columns={columns} dataSource={responseData} searchable locale={{ emptyText: 'Δεν Υπάρχουν Δεδομένα' }} ContractTab/>
    }
    return <Spinner />
}